import {
  Day,
  MaxSlot,
  MinSlot,
  UpdateWorkingHoursMutationInput,
  WorkingHoursTypeEnum,
  WorkingSettingInput,
} from "@clockwise/schema";
import { DateTime } from "luxon";

export const getDefaultWorkingHoursInput = (
  workingHoursId: string,
): UpdateWorkingHoursMutationInput => {
  const baseSetting: WorkingSettingInput = {
    minSlot: MinSlot.T_09_00,
    maxSlot: MaxSlot.T_16_30,
    excludedSlots: [],
  };
  const daySettings = [
    { day: Day.Monday, setting: baseSetting },
    { day: Day.Tuesday, setting: baseSetting },
    { day: Day.Wednesday, setting: baseSetting },
    { day: Day.Thursday, setting: baseSetting },
    { day: Day.Friday, setting: baseSetting },
  ];

  const workingHoursInput = {
    dayOverrides: [],
    daySettings: daySettings,
    type: WorkingHoursTypeEnum.Base,
    timeZone: DateTime.local().zoneName,
    id: workingHoursId,
  };

  return {
    saveMeetingAndWorkingHours: true,
    workingHours: workingHoursInput,
  };
};
